// src/components/common/bulk/ProgressIndicator.jsx
import React from 'react';
import { Loader2 } from 'lucide-react';
import styles from './ProgressIndicator.module.css';

const ProgressIndicator = ({ step, progress, entityLabel = 'order' }) => {
  const percentage = progress.total > 0
    ? (progress.current / progress.total) * 100
    : 0;

  const getMessage = () => {
    switch (step) {
      case 'validate':
        return `Validating ${entityLabel} ${progress.current} of ${progress.total}`;
      case 'submit':
        return `Creating ${entityLabel} ${progress.current} of ${progress.total}`;
      default:
        return 'Processing...';
    }
  };

  return (
    <div className={styles.progressIndicator}>
      <div className={styles.icon}>
        <Loader2 size={48} className={styles.spinning} />
      </div>
      <div className={styles.message}>{getMessage()}</div>
      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className={styles.count}>
        {progress.current} / {progress.total}
      </div>
    </div>
  );
};

export default ProgressIndicator;
